import { DeploymentProviders } from "utils/deployment-providers-util";

export const GoogleRegions = [
  "asia-east1",
  "asia-east2",
  "asia-northeast1",
  "asia-northeast2",
  "asia-south1",
  "asia-southeast1",
  "australia-southeast1",
  "europe-north1",
  "europe-west1",
  "europe-west2",
  "europe-west3",
  "europe-west4",
  "europe-west6",
  "northamerica-northeast1",
  "southamerica-east1",
  "us-central1",
  "us-east1",
  "us-east4",
  "us-west1",
  "us-west2",
];

export const AWSRegions = [
  "us-east-2",
  "us-east-1",
  "us-west-1",
  "us-west-2",
  "ap-east-1",
  "ap-south-1",
  "ap-northeast-3",
  "ap-northeast-2",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-northeast-1",
  "ca-central-1",
  "cn-north-1",
  "cn-northwest-1",
  "eu-central-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "eu-north-1",
  "me-south-1",
  "sa-east-1",
  "us-gov-east-1",
  "us-gov-west-1",
];

export const ABSRegions = [
  "asia",
  "asiapacific",
  "australia",
  "australiacentral",
  "australiacentral2",
  "australiaeast",
  "australiasoutheast",
  "brazil",
  "brazilsouth",
  "brazilsoutheast",
  "canada",
  "canadacentral",
  "canadaeast",
  "centralindia",
  "centralus",
  "centraluseuap",
  "centralusstage",
  "eastasia",
  "eastasiastage",
  "eastus",
  "eastus2",
  "eastus2euap",
  "eastus2stage",
  "eastusstage",
  "europe",
  "francecentral",
  "francesouth",
  "germanynorth",
  "germanywestcentral",
  "global",
  "india",
  "japan",
  "japaneast",
  "japanwest",
  "jioindiawest",
  "koreacentral",
  "koreasouth",
  "northcentralus",
  "northcentralusstage",
  "northeurope",
  "norwayeast",
  "norwaywest",
  "southafricanorth",
  "southafricawest",
  "southcentralus",
  "southcentralusstage",
  "southeastasia",
  "southeastasiastage",
  "southindia",
  "switzerlandnorth",
  "switzerlandwest",
  "uaecentral",
  "uaenorth",
  "uk",
  "uksouth",
  "ukwest",
  "unitedstates",
  "westcentralus",
  "westeurope",
  "westindia",
  "westus",
  "westus2",
  "westus2stage",
  "westus3",
  "westusstage",
];

const LinodeRegions = [
  "us-southeast",
  "us-ord",
  "us-central",
  "us-west",
  "us-lax",
  "us-mia",
  "us-east",
  "us-sea",
  "us-iad",
  "ca-central",
  "se-sto",
  "nl-ams",
  "it-mil",
  "eu-west",
  "gb-lon",
  "fr-par",
  "es-mad",
  "eu-central",
  "de-fra-2",
  "ap-south",
  "sg-sin-2",
  "jp-osa",
  "ap-northeast",
  "jp-tyo-3",
  "in-maa",
  "ap-west",
  "in-bom-2",
  "id-cgk",
  "br-gru",
  "au-mel",
  "ap-southeast",
];

export const WasabiRegions = [
  "us-east-1",
  "us-east-2",
  "us-central-1",
  "us-west-1",
  "us-west-2",
  "ca-central-1",
  "eu-central-1",
  "eu-central-2",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "eu-south-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-southeast-1",
  "ap-southeast-2",
];

export const BackblazeRegions = ["us-east", "us-west", "eu-central", "ca-east"];

export const OnPremRegions = ["us-east-1"];

export const ProviderRegionMap: Record<DeploymentProviders, string[]> = {
  [DeploymentProviders.Aws]: AWSRegions,
  [DeploymentProviders.Backblaze]: BackblazeRegions,
  [DeploymentProviders.Linode]: LinodeRegions,
  [DeploymentProviders.Wasabi]: WasabiRegions,
  [DeploymentProviders.StoreOne]: OnPremRegions,
};
